import { BaseEdge, EdgeLabelRenderer, type EdgeProps, getStraightPath } from '@xyflow/react'
import { type FC, useState } from 'react'
import { FlowBranchAction } from 'widgets/Flow/ui/FlowBranchAction/FlowBranchAction'
import { AddActionDropdown } from './AddActionDropdown/AddActionDropdown'

export function FlowCustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  source,
  target,
  Content,
  disabled,
  noActions,
}: EdgeProps & {
  Content: FC<{ setOpen: (value: boolean) => void; source: string; target: string }>
  viewOnly?: boolean
  disabled?: boolean
  noActions?: boolean
}) {
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  })

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(!open)
  }

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          strokeWidth: 2,
          stroke: disabled ? 'var(--content-primary-disabled)' : 'var(--light-blue-60)',
        }}
      />
      {!noActions && (
        <EdgeLabelRenderer>
          <FlowBranchAction
            labelX={labelX}
            labelY={labelY}
            open={open}
            onClick={handleOpen}
            disabled={disabled}
          />

          {open && (
            <AddActionDropdown labelX={labelX} labelY={labelY} setOpen={setOpen}>
              <Content source={source} target={target} setOpen={setOpen} />
            </AddActionDropdown>
          )}
        </EdgeLabelRenderer>
      )}
    </>
  )
}
